import accessors from '../accessors';

const canBeTextResizable = (element) =>
  Boolean(accessors.getTextResizeConstraintForElement(element));

export default canBeTextResizable;
